import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n'], ['\n  background-color: white;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  background-color: white;\n  bottom: 0; \n  width: 100vw; \n  justify-content: center; \n  align-items: center; \n  display: flex;\n  flex-direction: column;\n'], ['\n  position: fixed;\n  background-color: white;\n  bottom: 0; \n  width: 100vw; \n  justify-content: center; \n  align-items: center; \n  display: flex;\n  flex-direction: column;\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  .otnotice-menu,\n  .otnotice-menu-mobile,\n  .otnotice-menu-content {\n    display: none;\n  }\n\n  p {\n    text-align: left;\n    font-family: ', ';\n  }\n\n  h2 {\n    color: ', ';\n    font-family: ', ';\n    font-size: 20px;\n  }\n'], ['\n  .otnotice-menu,\n  .otnotice-menu-mobile,\n  .otnotice-menu-content {\n    display: none;\n  }\n\n  p {\n    text-align: left;\n    font-family: ', ';\n  }\n\n  h2 {\n    color: ', ';\n    font-family: ', ';\n    font-size: 20px;\n  }\n']),
  _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  font-size: ', 'px;\n  font-weight: bold;\n  color: ', ';\n'], ['\n  font-family: ', ';\n  font-size: ', 'px;\n  font-weight: bold;\n  color: ', ';\n']),
  _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-color: #6c757d !important;\n  opacity: 0.65;\n'], ['\n  background-color: #6c757d !important;\n  opacity: 0.65;\n']),
  _templateObject6 = _taggedTemplateLiteralLoose(['\n  color: red;\n'], ['\n  color: red;\n']),
  _templateObject7 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']);
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React, { Fragment } from 'react';
import Paragraph from '../Paragraph';
import Theme from '../../Theme';
import { Button } from '../Dashboard/Button';
import { ModalFooter, Row, Col, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import './styles.css';
var Body = styled(ModalBody)(_templateObject);
var Footer = styled(ModalFooter)(_templateObject2);
var OneTrustFrame = styled.div(_templateObject3, Theme.fonts.Montserrat, Theme.colors.primary, Theme.fonts.PlayfairDisplay);
var Title = styled.div(_templateObject4, function (props) {
  return props.fontFamily || Theme.fonts.PlayfairDisplay;
}, function (props) {
  return props.mdFont ? '20' : '32';
}, Theme.colors.primary);
var DisabledButton = styled(Button)(_templateObject5);
var ErrorMessage = styled.p(_templateObject6);
var ButtonContainer = styled.div(_templateObject7);
var ConsentModal = function ConsentModal(_ref) {
  var data = _ref.data,
    mutation = _ref.mutation,
    history = _ref.history;
  var _React$useState = React.useState(false),
    isFinishedScrolling = _React$useState[0],
    setIsFinishedScrolling = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isSubmitting = _React$useState2[0],
    setIsSubmitting = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    hasClickError = _React$useState3[0],
    setHasClickError = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    hasSubmissionError = _React$useState4[0],
    setHasSubmissionError = _React$useState4[1];
  React.useEffect(function () {
    window.OneTrust.NoticeApi.Initialized.then(function () {
      window.OneTrust.NoticeApi.LoadNotices(['https://privacyportal-cdn.onetrust.com/d026f30a-622a-40b3-b261-d78a6b839240/privacy-notices/e5ba731c-ccde-479b-96cc-c6fd04efc8bb.json']);
    });
    window.addEventListener('scroll', checkScrollPosition);
    return function () {
      window.removeEventListener('scroll', checkScrollPosition);
    };
  }, []);
  var checkScrollPosition = function checkScrollPosition() {
    var _document$documentEle = document.documentElement,
      scrollTop = _document$documentEle.scrollTop,
      scrollHeight = _document$documentEle.scrollHeight,
      clientHeight = _document$documentEle.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight * 0.80) {
      setIsFinishedScrolling(true);
      setHasClickError(false);
    }
  };
  var handleDisabledClick = function handleDisabledClick() {
    return setHasClickError(true);
  };
  var handleSubmit = function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsSubmitting(true);
              _context.next = 4;
              return mutation({
                variables: {
                  input: {
                    identifier: data.primaryEmail || data.loginEmail
                  }
                }
              });
            case 4:
              history.go(0);
              _context.next = 11;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);
              setHasSubmissionError(true);
              if (window.rg4js) {
                window.rg4js('send', {
                  error: _context.t0,
                  tags: ['ConsentModal']
                });
              }
            case 11:
              _context.prev = 11;
              setIsSubmitting(false);
              return _context.finish(11);
            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7, 11, 14]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return React.createElement(Fragment, null, React.createElement(Body, {
    'data-testid': 'modal-body',
    onScroll: checkScrollPosition
  }, React.createElement(Title, {
    className: 'mb-4'
  }, 'Our Policies Have Changed'), React.createElement(Paragraph, {
    fw: 'normal',
    className: 'mb-2'
  }, 'To continue, please review the following information:'), React.createElement(Row, {
    className: 'mt-2 mb-4'
  }, React.createElement(Col, null, React.createElement(OneTrustFrame, {
    id: 'otnotice-e5ba731c-ccde-479b-96cc-c6fd04efc8bb',
    className: 'otnotice',
    'data-testid': 'frame'
  }))), React.createElement(Footer, null, React.createElement(ButtonContainer, null, hasClickError && !isSubmitting && React.createElement(ErrorMessage, null, 'Before clicking "Agree to Terms of Service", you must review the policy above.'), hasSubmissionError && !hasClickError && !isSubmitting && React.createElement(ErrorMessage, {
    'data-testid': 'error-message'
  }, 'There was a problem while submitting, please try again later.'), !isSubmitting ? isFinishedScrolling ? React.createElement(Button, {
    'data-testid': 'enabled-btn',
    onClick: handleSubmit
  }, 'Agree to Terms of Service') : React.createElement(DisabledButton, {
    'data-testid': 'disabled-btn',
    onClick: handleDisabledClick
  }, ' Agree to Terms of Service') : React.createElement(Paragraph, {
    style: {
      fontWeight: '600'
    }
  }, React.createElement('div', {
    className: 'spinner-border spinner-border-sm',
    'data-testid': 'submitting'
  }), ' Submitting...')), React.createElement('a', {
    className: 'mt-2',
    href: '/logout'
  }, 'RETURN TO PUBLIC CONTENT'))));
};
ConsentModal.displayName = 'ConsentModal';
ConsentModal.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  mutation: PropTypes.func,
  history: PropTypes.object
} : {};
export default ConsentModal;